export default {
  pt: {
    pageTitle: "Foto",
    titleReview: "Revisar foto",
    titleTake: "Hora da selfie!",
    subtitleReview: "A foto está nítida e iluminada?<br />Não pode ter reflexo.",
    subtitleTake:
      "Não precisa ser a foto perfeita, mas temos algumas regrinhas que vão te ajudar no processo.",
    continueButton: "Continuar",
    looksGoodButton: "Ficou legal!",
    takeAnotherButton: "Tirar outra",
    rule1Text: "Não use acessórios",
    rule2Text: "Não use óculos",
    rule3Text: "Enquadre seu rosto",
    handoffDescription:
      "Para tirar a selfie, escaneie o QR code com a câmera do seu celular e continue por lá.",
  },

  en: {
    pageTitle: "Photo",
    titleReview: "Review photo",
    titleTake: "Selfie time!",
    subtitleReview: "Is the photo clear and well-lit?<br />No reflection allowed.",
    subtitleTake:
      "It doesn't need to be the perfect photo, but we have some rules that will help you in the process.",
    continueButton: "Continue",
    looksGoodButton: "Looks good!",
    takeAnotherButton: "Take another",
    rule1Text: "Don't use accessories",
    rule2Text: "Don't use glasses",
    rule3Text: "Frame your face",
    handoffDescription:
      "To take the selfie, scan the QR code with your phone's camera and continue from there.",
  },
};
